import { configureStore } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";
import authSlice from "@Store/Slices/authSlice";
import zonesSlice from "@Store/Slices/zonesSlice";
import wardsSlice from "@Store/Slices/wardsSlice";
import usersSlice from "@Store/Slices/usersSlice";
import rolesSlice from "@Store/Slices/rolesSlice";
import settingsSlice from "@Store/Slices/settingsSlice";
import dashboardSlice from "@Store/Slices/dashboardSlice";
import notificationsSlice from "@Store/Slices/notificationSlice";
import stateSlice from "@Store/Slices/stateSlice";
import citySlice from "@Store/Slices/citySlice";
import commonSlice from "@Store/Slices/commonSlice";
import UsersSliceNew from "@Store/Slices/UsersSliceNew";
import locationSlice from "@Store/Slices/locationSlice";
import deviceSlice from "@Store/Slices/deviceSlice";
import otaSlice from "@Store/Slices/otaSlice";
import telemetryLiveSlice from "@Store/Slices/telemetryLiveSlice";
import configSlice from "@Store/Slices/configSlice";
export const store = configureStore({
  reducer: {
    authSlice: authSlice,
    zonesSlice: zonesSlice,
    wardsSlice: wardsSlice,
    usersSlice: usersSlice,
    rolesSlice: rolesSlice,
    settingsSlice: settingsSlice,
    notificationsSlice: notificationsSlice,
    dashboardSlice: dashboardSlice,
    stateSlice: stateSlice,
    citySlice: citySlice,
    commonSlice: commonSlice,
    userSliceNew: UsersSliceNew,
    locationSlice: locationSlice,
    deviceSlice: deviceSlice,
    otaSlice: otaSlice,
    telemetryLiveSlice: telemetryLiveSlice,
    configSlice: configSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export default store;
